module.exports = __webpack_public_path__ + "static/media/SeeingSound_01.326650cd.JPG";